import { convertCharterFullWidth } from "@lhd/utility";
import { ChangeEvent, useState } from "react";
import { ICommonFieldProps } from "../../../../interfaces";

const RegisterCodeEditCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange } = props;
  const [value, setValue] = useState(String(defaultValue ?? ""));

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value.replace(/[^0-9０-９－-]/g, "");

    setValue(nextValue);
    onChange?.(nextValue);
  };

  const handleBlur = () => {
    const formattedValue = convertCharterFullWidth(value).replace(
      /[^0-9-]/g,
      "",
    );

    setValue(formattedValue);
    onChange?.(formattedValue);
  };

  return (
    <input
      className="input-field"
      type="text"
      value={value}
      pattern="[0-9-]*"
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default RegisterCodeEditCell;
